import { panelSharedProps as e } from "./index935.js";
import { buildProps as r, definePropType as p } from "./index601.js";
const a = r({
  ...e,
  parsedValue: {
    type: p([Object, Array])
  },
  visible: {
    type: Boolean,
    default: !0
  },
  format: {
    type: String,
    default: ""
  }
});
export {
  a as panelDatePickProps
};
